import { render, staticRenderFns } from "./LookupTableComponent.vue?vue&type=template&id=1a58e31a&scoped=true&"
import script from "./LookupTableComponent.vue?vue&type=script&lang=js&"
export * from "./LookupTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./LookupTableComponent.vue?vue&type=style&index=0&id=1a58e31a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a58e31a",
  null
  
)

export default component.exports